module.exports = "/* input.ng-invalid.ng-touched,\r\ntextarea.ng-invalid.ng-touched,\r\nselect.ng-invalid.ng-touched {\r\n  border: 1px solid red;\r\n} */\r\n\r\n.InvalidZipCls {\r\n  border: 1px solid red;\r\n}\r\n\r\n.alert-warning {\r\n  color: #333;\r\n  padding: 2px 12px;\r\n  width: 81%;\r\n  font-size: 12px;\r\n}\r\n\r\n.red-asterisk {\r\n  color: red\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shoppingcart/create-account/create-account.component.css
// module id = ./src/app/shoppingcart/create-account/create-account.component.css
// module chunks = main